enum SchemaPolicyType {
  SingleTrip = 'Single Trip',
  AnnualMultiTrip = 'Annual',
}

enum SchemaTripTypeCode {
  SingleTrip = 'singleTrip',
  AnnualMultiTrip = 'annualMultiTrip',
}

enum SchemaTravellersType {
  NotListed = 'notListed',
  Listed = 'listed',
}

enum SchemaTravellersRelationship {
  BusinessPartner = 'businessPartner',
  TravelCompanion = 'travelCompanion',
  Relative = 'relative',
  Friend = 'friend',
  Other = 'other',
}

enum SchemaRadioYesOrNo {
  Yes = 'true',
  No = 'false',
}

enum SchemaIncidentTiming {
  PreTrip = 'preTrip',
  OnTrip = 'onTrip',
}

enum SchemaIncidentMainCause {
  Dental = 'dental',
  Illness = 'illness',
  Injury = 'injury',
}

enum SchemaDentalTreatmentType {
  Cosmetic = 'cosmetic',
  Emergency = 'emergency',
  Routine = 'routine',
}

enum SchemaInjuryType {
  BrokenBonesOrFractures = 'brokenBonesOrFractures',
  SprainOrTearInMusclesOrLigaments = 'sprainOrTearInMusclesOrLigaments',
  AccidentOrOther = 'accidentOrOther',
}

enum SchemaInjuryCause {
  AccidentalFall = 'accidentalFall',
  AdventureActivity = 'adventureActivity',
  Assault = 'assault',
  MotorVehicle = 'vehicle',
  SnowSports = 'snowSports',
  Other = 'other',
}

enum SchemaVehicleType {
  Car = 'car',
  MotorcycleOrMoped = 'motorcycleOrMoped',
  Other = 'other',
}

enum SchemaEngineCapacity {
  AtLeast250cc = 'atLeast250cc',
  LessThan250cc = 'lessThan250cc',
}

enum SchemaPersonalInvolvement {
  Driver = 'driver',
  Passenger = 'passenger',
  Pedestrian = 'pedestrian',
}

enum SchemaIncidentLocation {
  Accommodation = 'accommodation',
  Airport = 'airport',
  Cruise = 'cruise',
  Plane = 'plane',
  PublicPlace = 'publicPlace',
  TrainOrBus = 'trainOrBus',
  Other = 'other',
}

enum SchemaMedicalExpenseType {
  MedicalConsultation = 'medicalConsultation',
  MedicationOrMedicalEquipment = 'medicationOrMedicalEquipment',
  MedicalTreatment = 'medicalTreatment',
  DentalTreatment = 'dentalTreatment',
}

enum SchemaCancellationExpenseType {
  Accommodation = 'accommodation',
  Cruise = 'cruise',
  Flight = 'flight',
  Tour = 'tour',
  Transport = 'transport',
  TravelPackage = 'travelPackage',
  Other = 'other',
}

enum SchemaAdditionalExpenseType {
  Accommodation = 'accommodation',
  Flight = 'flight',
  Transport = 'transport',
  Other = 'other',
}

enum SchemaProviderAccountType {
  SWIFT = 'swift',
  IBAN = 'iban',
}

enum SchemaPreferredContactMethod {
  Email = 'email',
  Phone = 'phone',
}

export {
  SchemaAdditionalExpenseType,
  SchemaCancellationExpenseType,
  SchemaDentalTreatmentType,
  SchemaEngineCapacity,
  SchemaIncidentLocation,
  SchemaIncidentMainCause,
  SchemaIncidentTiming,
  SchemaInjuryCause,
  SchemaInjuryType,
  SchemaMedicalExpenseType,
  SchemaPersonalInvolvement,
  SchemaPolicyType,
  SchemaPreferredContactMethod,
  SchemaProviderAccountType,
  SchemaRadioYesOrNo,
  SchemaTravellersRelationship,
  SchemaTravellersType,
  SchemaTripTypeCode,
  SchemaVehicleType,
};
